import { EditableInput } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SEditableInput = styled(EditableInput)``;
